/**
 * Constantes del feature de incidencias
 */

import { INCIDENCIA_ESTADO_VALOR, INCIDENCIA_TIPO } from "../../config/constants";

// Estados de incidencias
export const ESTADOS = {
  ABIERTA: 1,
  EN_REVISION: 2,
  CERRADA: 3,
};

export const ESTADOS_LABELS = {
  [ESTADOS.ABIERTA]: "Abierto",
  [ESTADOS.EN_REVISION]: "En Revisión",
  [ESTADOS.CERRADA]: "Cerrado",
};

export const ESTADOS_OPTIONS = [
  { label: "Abierto", value: ESTADOS.ABIERTA },
  { label: "En Revisión", value: ESTADOS.EN_REVISION },
  { label: "Cerrado", value: ESTADOS.CERRADA },
];

// CSV de estados no cerrados para filtros API
export const ESTADOS_NO_CERRADOS = `${INCIDENCIA_ESTADO_VALOR.ABIERTA},${INCIDENCIA_ESTADO_VALOR.EN_PROCESO}`;

// Orígenes de incidencias
export const ORIGENES = {
  STICKER: "sticker",
  SALES: "sales",
  PURCHASES: "purchases",
  INVENTARIO: "inventario",
  ORDER: "order",
  NAVE2: "nave2",
};

export const ORIGENES_LABELS = {
  [ORIGENES.STICKER]: "Etiqueta",
  [ORIGENES.SALES]: "Ventas",
  [ORIGENES.PURCHASES]: "Compras",
  [ORIGENES.INVENTARIO]: "Inventario",
  [ORIGENES.ORDER]: "Pedido",
  [ORIGENES.NAVE2]: "Nave 2",
};

// Tipos de incidencias
export const TIPOS = {
  ART: INCIDENCIA_TIPO.ART,
  PED: INCIDENCIA_TIPO.PED,
  ALB: INCIDENCIA_TIPO.ALB,
};

export const TIPOS_LABELS = {
  [TIPOS.ART]: "Artículo",
  [TIPOS.PED]: "Pedido",
  [TIPOS.ALB]: "Albarán",
};
